import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Spinner, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { ArrowRight, Layers } from "lucide-react";

const SEV = { action: "border-amber-400", alert: "border-red-400", success: "border-emerald-400", info: "border-blue-400" };

export default function NotificationsPage() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/notifications").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items) return <Spinner />;
  return (
    <div>
      <PageHeader overline="Alerts" title="Notifications"
        subtitle="Status updates and requests scoped to your role. Technical configuration alerts are visible to administrators only."
        testid="notifications-header" />
      {items.length === 0 ? <EmptyState title="You're all caught up" /> : (
        <div className="space-y-3">
          {items.map((n) => (
            <Card key={n.id} className={`p-4 border-l-4 ${SEV[n.severity] || "border-slate-300"}`} data-testid="notification-item">
              <div className="flex justify-between gap-3">
                <span className="font-semibold flex items-center gap-2 min-w-0 flex-wrap">
                  <span className="break-words">{n.title}</span>
                  {n.count > 1 && (
                    <span data-testid="notification-group-count" className="inline-flex items-center gap-1 rounded-full bg-secondary px-2 py-0.5 text-[11px] font-semibold text-muted-foreground">
                      <Layers className="h-3 w-3" />×{n.count}
                    </span>
                  )}
                </span>
                <span className="text-xs text-muted-foreground whitespace-nowrap font-num shrink-0">{new Date(n.ts).toLocaleString()}</span>
              </div>
              {n.message && <p className="text-sm text-muted-foreground mt-1 break-words">{n.message}</p>}
              {n.link && (
                <Link to={n.link} data-testid="notification-link" className="inline-flex items-center gap-1 mt-2 text-xs font-semibold text-primary hover:underline min-h-[32px]">
                  View record <ArrowRight className="h-3 w-3" />
                </Link>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
